import { useNavigate } from "react-router-dom";
import "./checkSummery.css";


const Index = () => {
    // const navigate = useNavigate();
    const renderPay = () => (
        <div className="checks-wrapper">
            <h3 className="checks-title">Coming Soon…</h3>
            <div style={{ textAlign: "center" }}>
                {/* <span className="inline-loader" role="status" aria-live="polite" aria-label="Loading"> */}
                <span >This page is in progress and will be available shortly.</span>
                {/* </span> */}
            </div>
        </div>
    );


    return (
        <div className="checks-page">
            <div
                id="snackbar"
                className={`checks-toast`}
            >
                {/* <span>{toasterData.message}</span> */}
            </div>

            <div className="checks-container">
                <img src="/images/roaring_logo.svg" alt="EZmenu" className="checks-logo" />
                {renderPay()}
            </div>
        </div>
    );
};

export default Index;
